import { EmployeeSignUpSteps } from "./types";

export const employeeSignUpStepsArray = Object.keys(EmployeeSignUpSteps);
export const EMPLOYEE_SIGN_UP_STEPS_NUMBER = employeeSignUpStepsArray.length / 2;
